import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../layouts/se.layout.widget.abstract";
import { ManageRegistrationConfigComponent } from "../attendance/se.manage.registration.config.component";
import { Layouts } from "../layouts/se.layouts";
import { SeOrgSecurityStore } from "../se.org.security.store";

@Component({
    standalone: true,
    selector: "s25-ng-se-event-details-registration-config-widget",
    template: `
        @if (orgSecStore.canViewRegistration()) {
            <s25-ng-manage-registration-config />
        }
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ManageRegistrationConfigComponent],
})
export class SeEventDetailsRegistrationConfigWidgetComponent extends LayoutWidget<
    typeof SeEventDetailsRegistrationConfigWidgetComponent
> {
    static readonly META = {
        name: "Registration Configuration",
        info: "Shows registration options for the event when your role can view registration configuration",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected orgSecStore = inject(SeOrgSecurityStore);
}
